import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'

export default class Snow
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene)
    {
        this._scene = scene;

        this._snowParticles = [];

        this._scene.events.on(Phaser.Scenes.Events.PRE_UPDATE, this._update, this);
        this._scene.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this._scene.events.off(Phaser.Scenes.Events.PRE_UPDATE, this._update, this));
    }

    _update(time, delta)
    {
        this._createSnowParticle();

        delta /= 1000;

        this._snowParticles.forEach(snowParticle =>
        {
            //snowParticle.y += snowParticle.speedY * delta;
        });
    }

    _createSnowParticle()
    {
        let snowParticle = this._scene.add.circle(0, 0, Math.random() * 4, 0xffffff, 1);

        snowParticle.x = Math.random() * this._scene.scale.width;
        snowParticle.y = -snowParticle.height / 2;

        snowParticle.speedY = 1 + Math.random();

        this._snowParticles.push(snowParticle);

        ABCyaPhaser.Tweens.addTween(snowParticle, 5000, { y: this._scene.scale.height + snowParticle.height }, Phaser.Math.Easing.Sine.In, () => snowParticle.destroy());
    }
}